import { useApplicationParameters } from "src/api/client-api/appParams/useApplicationParameters";
import { useSsoConnectors } from "src/api/client-api/sso/useSsoConnectors";
import { attachConnectorLogos, resolveSsoLoginMode, SsoConnector, SsoLoginMode } from "./ssoConnector";

type UseSsoConnector = {
    connectors: SsoConnector[];
    loginMode: SsoLoginMode;
    isLoading: boolean;
};

export const useSsoConnector = (): UseSsoConnector => {
    const { applicationParameters, fullApplicationParameters, isLoading } = useApplicationParameters();
    const { connectors, isLoading: areConnectorsLoading } = useSsoConnectors();

    return {
        connectors: attachConnectorLogos(connectors, fullApplicationParameters ?? {}),
        loginMode: resolveSsoLoginMode(applicationParameters?.["sso-login-mode"]),
        isLoading: isLoading || areConnectorsLoading,
    };
};
